import { MenuItem } from '@/core/models';
import { CartCalculationRule, CartDomainContext } from '..';

export class CartItemProductChannelRule implements CartCalculationRule {
	/**
	 * Procesa los menu items y actualiza los precios del producto canal
	 */
	calculate(context: CartDomainContext): CartDomainContext {
		const processCartItem: MenuItem[] = context.menuItems.map(cartItem => {
			const channelProducts = cartItem?.productosCanal || [];

			return {
				...cartItem,
				productosCanal: channelProducts.map(channelProduct => ({
					...channelProduct,
					precios: channelProduct?.precios.map(price => ({
						...price,
						precio: price.precio ? BigInt(price.precio) : 0n,
						precioBase: price.precioBase ? BigInt(price.precioBase) : 0n,
					})),
				}))
			};
		});

		return {
			...context,
			menuItems: processCartItem,
		};
	}
}
